export interface CallCenterProfile {
  id: string;
  staffName: string;
  role: string;
  status: 'Active' | 'Inactive' | 'Suspended';
  queue: string;
  staffId: string;
}

export interface PersonalInfo {
  staffName: string;
  employeeId: string;
  assignedQueue: string;
}

export interface ContactInfo {
  email: string;
  phone: string;
  department: string;
}

export interface NotificationPreference {
  id: string;
  label: string;
  enabled: boolean;
}

export interface SecurityOption {
  id: string;
  label: string;
}

export interface SettingsItem {
  id: string;
  icon: 'bell' | 'globe' | 'wifi' | 'gear';
  title: string;
  subtitle: string;
}

export const defaultNotificationPreferences: NotificationPreference[] = [
  { id: 'new-ticket', label: 'New ticket assigned', enabled: true },
  { id: 'ticket-escalated', label: 'Ticket escalated', enabled: true },
  { id: 'sla-breach', label: 'SLA breach alerts', enabled: true },
  { id: 'resolution-notices', label: 'Resolution notices', enabled: false },
];

export const defaultSecurityOptions: SecurityOption[] = [
  { id: 'change-password', label: 'Change Password' },
];

export const defaultSettingsItems: SettingsItem[] = [
  { id: 'notifications', icon: 'bell', title: 'Notifications', subtitle: 'Manage notification preferences' },
  { id: 'language', icon: 'globe', title: 'Language', subtitle: 'English (US)' },
  { id: 'offline-mode', icon: 'wifi', title: 'Offline Mode', subtitle: 'Sync when online' },
  { id: 'general', icon: 'gear', title: 'General Settings', subtitle: 'App preferences and defaults' },
];
